import { useMemo } from "react";

import { SelectWithOptgroup } from "./select-with-optgroup";

import type { SelectWithOptgroupOption } from "./select-with-optgroup";
import type * as Model from "../../model";

type Props = {
	regionWithPrefectureTagList: Model.Type.ViewData["regionWithPrefectureTagList"];
	selectedPrefectureTag: Model.Type.ViewModel["selectedPrefectureTag"];
	onSelect: (prefectureTag: string) => void;
};

export const RegionWithPrefectureSelectField = ({
	regionWithPrefectureTagList,
	selectedPrefectureTag,
	onSelect,
}: Props) => {
	const selectFieldOptions = useMemo(
		(): Array<SelectWithOptgroupOption> =>
			regionWithPrefectureTagList.map(({ regionTag, prefectureTagList }) => ({
				label: regionTag,
				children: prefectureTagList.map((prefectureTag) => ({
					key: prefectureTag,
					value: prefectureTag,
				})),
			})),
		[regionWithPrefectureTagList],
	);

	return (
		<SelectWithOptgroup
			label="都道府県"
			value={selectedPrefectureTag}
			options={selectFieldOptions}
			onChangeCallback={onSelect}
		/>
	);
};
